"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOnboardingQuestionOptionDto = instanceOfOnboardingQuestionOptionDto;
exports.OnboardingQuestionOptionDtoFromJSON = OnboardingQuestionOptionDtoFromJSON;
exports.OnboardingQuestionOptionDtoFromJSONTyped = OnboardingQuestionOptionDtoFromJSONTyped;
exports.OnboardingQuestionOptionDtoToJSON = OnboardingQuestionOptionDtoToJSON;
exports.OnboardingQuestionOptionDtoToJSONTyped = OnboardingQuestionOptionDtoToJSONTyped;
var DigestCopyDto_1 = require("./DigestCopyDto");
/**
 * Check if a given object implements the OnboardingQuestionOptionDto interface.
 */
function instanceOfOnboardingQuestionOptionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function OnboardingQuestionOptionDtoFromJSON(json) {
    return OnboardingQuestionOptionDtoFromJSONTyped(json, false);
}
function OnboardingQuestionOptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'label': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['label']),
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'groupLabel': json['groupLabel'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['groupLabel']),
    };
}
function OnboardingQuestionOptionDtoToJSON(json) {
    return OnboardingQuestionOptionDtoToJSONTyped(json, false);
}
function OnboardingQuestionOptionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'label': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['label']),
        'sortOrder': value['sortOrder'],
        'groupId': value['groupId'],
        'groupLabel': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['groupLabel']),
    };
}
